










import { Component, Vue } from 'vue-property-decorator';

import { DailyReportStore } from '@/store/dailyReport';

@Component
export default class IndexPageTankFieldsShownToggle extends Vue {
  @DailyReportStore.Bind.State isTankFieldsShown!: DailyReportStore.State<'isTankFieldsShown'>;
  @DailyReportStore.Bind.Mutation setTankFields!: DailyReportStore.Mutation<'setTankFields'>;
}
